class LocalizationAccordionGroup extends HTMLElement {
	#controller = new AbortController();

	connectedCallback() {
		this.addEventListener('toggle', this.#onToggle, {
			capture: true,
			signal: this.#controller.signal,
		});

		requestAnimationFrame(() => this.#openDefault());
	}

	disconnectedCallback() {
		this.#controller.abort();
	}

	get #sections() {
		return Array.from(this.querySelectorAll('.localization-accordion__details'));
	}

	#openDefault() {
		const sections = this.#sections;
		if (sections.length === 0) return;
		if (sections.some((section) => section.open)) return;

		sections[0].open = true;
	}

	#onToggle = (event) => {
		const opened = event.target;

		if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
		if (!opened.classList.contains('localization-accordion__details')) return;

		for (const section of this.#sections) {
			if (section !== opened) section.open = false;
		}
	};
}

if (!customElements.get('localization-accordion-group')) {
	customElements.define('localization-accordion-group', LocalizationAccordionGroup);
}
